'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { Heading } from '../ui/heading';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

export function MobileMenu({ menus }: { menus: Menu[] }) {
  return (
    <Accordion
      type="single"
      collapsible
      className="flex w-full flex-col items-start justify-start sm:hidden"
    >
      {menus.map((menu, index) => (
        <AccordionItem
          key={menu.name}
          value={menu.name}
          className={cn(
            'w-full px-0 py-4',
            index === 0 ? 'border-t-0' : 'border-t',
            'border-t-white/20',
          )}
        >
          <AccordionTrigger
            hideIcon
            className={cn(
              'flex w-full items-center justify-between p-0',
              'ea-mobile-menu__trigger',
            )}
          >
            <Heading title={menu.name} tag="h5" as="span" className={{ title: 'text-white' }} />
            <div
              className={cn(
                'minus',
                'flex h-6 min-w-6 max-w-6 items-center justify-center rounded-none bg-white/20',
              )}
            >
              <IoIosArrowUp className="h-3 w-3 text-white" />
            </div>
            <div
              className={cn(
                'plus',
                'flex h-6 min-w-6 max-w-6 items-center justify-center rounded-none bg-white/20',
              )}
            >
              <IoIosArrowDown className="h-3 w-3 text-white" />
            </div>
          </AccordionTrigger>
          <AccordionContent
            className={cn(
              'flex w-full flex-col items-start justify-start gap-2 p-0 pt-4',
              'ea-mobile-menu__content',
            )}
          >
            {menu.fields.map(field => (
              <Link
                key={field.name}
                href={getSafeHref(field?.path ?? '#')}
                className="text-base tracking-tight text-white transition-all hover:text-white/70"
              >
                {field.name}
              </Link>
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
